const pageNameKey = "unsavedStructureModal";

export const unsavedStructureModalEn = {
  [pageNameKey]: {
    subTitle: "Are you sure?",
    title: "Unsaved changes",
    descriptionFirstLine: "Do you really want to exit without saving?",
    descriptionSecondLine: "All unsaved changes will be discarded.",
    exitWithoutSavingButton: "Exit without saving",
    saveStructureButtonText: "Save changes and exit",
  },
};

export const unsavedStructureModalPtBr = {
  [pageNameKey]: {
    subTitle: "Tem certeza?",
    title: "Alterações não salvas",
    descriptionFirstLine: "Você realmente deseja sair sem salvar?",
    descriptionSecondLine: "Todas as alterações não salvas serão descartadas.",
    exitWithoutSavingButton: "Sair sem salvar",
    saveStructureButtonText: "Salvar alterações e sair",
  },
};

export const unsavedStructureModalDe = {
  [pageNameKey]: {
    subTitle: "Sind Sie sicher?",
    title: "Nicht gespeicherte Änderungen",
    descriptionFirstLine: "Möchten Sie wirklich ohne Speichern beenden?",
    descriptionSecondLine:
      "Alle nicht gespeicherten Änderungen werden verworfen.",
    exitWithoutSavingButton: "Ohne Speichern beenden",
    saveStructureButtonText: "Änderungen speichern",
  },
};

export const unsavedStructureModalZhHans = {
  [pageNameKey]: {
    subTitle: "你确定吗？",
    title: "未保存的更改",
    descriptionFirstLine: "你真的要在不保存的情况下退出吗？",
    descriptionSecondLine: "所有未保存的更改将被丢弃。",
    exitWithoutSavingButton: "退出而不保存",
    saveStructureButtonText: "保存更改并退出",
  },
};

export const unsavedStructureModalIt = {
  [pageNameKey]: {
    subTitle: "Sei sicuro?",
    title: "Modifiche non salvate",
    descriptionFirstLine: "Vuoi davvero uscire senza salvare?",
    descriptionSecondLine: "Tutte le modifiche non salvate verranno eliminate.",
    exitWithoutSavingButton: "Esci senza salvare",
    saveStructureButtonText: "Salva modifiche ed esci",
  },
};

export const unsavedStructureModalEs = {
  [pageNameKey]: {
    subTitle: "¿Estás seguro?",
    title: "Cambios no guardados",
    descriptionFirstLine: "¿Realmente quieres salir sin guardar?",
    descriptionSecondLine: "Se descartarán todos los cambios no guardados.",
    exitWithoutSavingButton: "Salir sin guardar",
    saveStructureButtonText: "Guardar cambios y salir",
  },
};

export const unsavedStructureModalNl = {
  [pageNameKey]: {
    descriptionFirstLine: "Wilt u echt afsluiten zonder op te slaan?",
    descriptionSecondLine:
      "Alle niet-opgeslagen wijzigingen worden verwijderd.",
    exitWithoutSavingButton: "Afsluiten zonder op te slaan",
    saveStructureButtonText: "Wijzigingen opslaan en afsluiten",
    subTitle: "Weet u het zeker?",
    title: "Niet-opgeslagen wijzigingen",
  },
};

export const unsavedStructureModalTr = {
  [pageNameKey]: {
    descriptionFirstLine: "Gerçekten kaydetmeden çıkmak istiyor musunuz?",
    descriptionSecondLine: "Kaydedilmemiş tüm değişiklikler silinecektir.",
    exitWithoutSavingButton: "Kaydetmeden çık",
    saveStructureButtonText: "Değişiklikleri kaydedin ve çıkın",
    subTitle: "Emin misin?",
    title: "Kaydedilmemiş değişiklikler",
  },
};
